import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, FormGroup, FormLabel, FormControl, Button, Image, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { useResto } from '../contexts/RestoContext';
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';
import { ucfirst } from '../utils/utils';

const SupplierAddItem = ({ handleAddItem }) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const { restoData } = useResto();
  const { setIsLoading } = useWebsite();

  const [formData, setFormData] = useState({
    website: '',
    descriptionFr: '',
    descriptionEn: '',
    descriptionDe: '',
    descriptionEs: '',
    label: '',
    url: '',
  });

  // 🔹 Met à jour le website quand restoData arrive
  useEffect(() => {
    if (restoData?.website) {
      setFormData(prev => ({
        ...prev,
        website: restoData.website
      }));
    }
  }, [restoData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData(prev => ({
      ...prev,
      label: '',
      url: '',
      descriptionFr: '',
      descriptionEn: '',
      descriptionDe: '',
      descriptionEs: ''
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(
        `${config.apiUrl}supplier`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      handleAddItem();
      resetForm();
      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success');

    } catch (error) {
      console.error(error);
      setFlashMessage(t('ERROR_MESSAGE'), 'error');
    }

    setIsLoading(false);
  };

  const availableLanguages = restoData?.availableLanguages || ['fr'];

  return (
    <div className="p-3">
      <Form onSubmit={handleSubmit}>

        {/* Nom fournisseur */}
        <Row className="mt-3">
          <Col>
            <FormGroup>
              <FormLabel>Nom du fournisseur</FormLabel>
              <FormControl
                type="text"
                name="label"
                value={formData.label}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
        </Row>

        {/* URL */}
        <Row className="mt-3">
          <Col>
            <FormGroup>
              <FormLabel>{t('URL')}</FormLabel>
              <FormControl
                type="url"
                name="url"
                value={formData.url}
                onChange={handleChange}
                placeholder="https://www.mon-fournisseur.fr"
              />
            </FormGroup>
          </Col>
        </Row>

        {/* Descriptions multilingues */}
        <Row className="mt-3">
          {availableLanguages.map((language) => (
            <Col key={language}>
              <FormGroup>
                <FormLabel>
                  Description{' '}
                  <Image
                    src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`}
                    className="flag-label"
                    alt={language}
                  />
                </FormLabel>

                <FormControl
                  as="textarea"
                  rows={3}
                  name={`description${ucfirst(language)}`}
                  value={formData[`description${ucfirst(language)}`] || ''}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          ))}
        </Row>

        {/* Bouton submit */}
        <div className="text-center mt-4" style={{ marginBottom: '60px' }}>
          <Button type="submit">
            {t('ADD')}
          </Button>
        </div>

      </Form>
    </div>
  );
};

export default SupplierAddItem;